var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{staticClass:"container"},[_c('a-layout-header',[_c('custom-header',{ref:"customHeader"})],1),_c('a-layout-content',[_c('router-view',{on:{"loginShow":_vm.loginModelShow}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }